import './BetbookAnalysisDetail.less';
import './BetbookAnalysisDetail.dark.less';

import BetbookPostDetailHeader from '../betbook-post-detail-header/BetbookPostDetailHeader';
import BetbookPostInfoBar from '../betbook-post-info-bars/BetbookPostInfoBar';
import BetbookRewardProgressBar from '../betbook-reward-progress-bar/BetbookRewardProgressBar';
import BetbookScoreboard from '../betbook-scoreboard/BetbookScoreboard';
import BetbookUserHeader from '../betbook-analysis-user-header/BetbookUserHeader';
import Markdown from '../markdown/Markdown';
import NuiDate from '../nui-date/NuiDate';
import React from 'react';
import clsx from 'clsx';
import i18n from '../../common/i18n';
import moment from 'moment';
import { BetbookAnalysisDetailProps } from './types';
import { BetbookContextProvider } from '../../common/BetbookContext';
import { getCalendarFormattedDate } from '../betbook/utils';

export default function BetbookAnalysisDetail({
    betComponent,
    betbookPostItemTicket,
    betbookDetailReactions,
    betbookRewardProgressBarChildren,
    className,
    header = null,
    isLoggedIn = false,
    post,
    onProfileDialog,
    onOptionDialog,
    optionContent,
    ownPost
}: BetbookAnalysisDetailProps) {
    const { id: postId, text, title, creationDate, modificationDate, commentCount = 0 } = post || {};
    const { inspirationCount = 0, author, pick, viewCount, reward, ticket: postTicket } = post || {};
    const { status = 'HIDDEN', value, maxValue, bonus, bonusPercent } = reward || {};
    const { evaluatedBets, successfulBets } = author || {};
    const { betId, betSelectionCode, sportId, expiration, matchHeaders, tournament } = pick || {};
    const successRate = (successfulBets / evaluatedBets) * 100;
    const hash = postTicket.hash;
    const creationDateFormatted = getCalendarFormattedDate(moment(creationDate));

    function replaceNewLines(text) {
        return text.replace(/\n/gm, '<br/>').replace(/\n+/gm, '<br/><br/>');
    }

    return (
        <>
            {header}
            <BetbookContextProvider
                betbookPostId={postId}
                betbookPostType="ANALYSIS"
                betbookPostAuthor={author?.contractId}
                betbookBetId={betId}
                betbookBetSelectionCode={betSelectionCode}
            >
                <div
                    className={clsx('analysis-detail', className)}
                    data-atid="betbook-analysis-item"
                    data-betbook-nickname={author?.nickname}
                    data-betbook-type="ANALYSIS"
                    data-betbook-id={postId}
                    data-betbook-title={title}
                >
                    <BetbookPostDetailHeader
                        onOptionButton={onOptionDialog}
                        showOptionsButton={isLoggedIn}
                        optionContent={optionContent}
                        sportId={sportId}
                        title={!optionContent && title}
                    />
                    <div className="p-rel">
                        <BetbookScoreboard
                            matchStartDate={expiration}
                            participants={matchHeaders}
                            sportId={sportId}
                            tournamentName={tournament}
                            iconSize={optionContent && '28'}
                        />
                        <BetbookPostInfoBar
                            className="detail"
                            inspirations={inspirationCount}
                            deposit={postTicket?.stake}
                            seen={viewCount}
                            comments={commentCount}
                        />
                    </div>
                    <div className="betbook-analysis-detail-center">
                        <BetbookUserHeader
                            author={author}
                            onProfileClick={onProfileDialog}
                            ownPost={ownPost}
                            successRate={successRate}
                        />
                        {reward && (
                            <BetbookRewardProgressBar
                                status={status}
                                value={value}
                                maxValue={maxValue}
                                bonus={bonus}
                                bonusPercent={bonusPercent}
                            >
                                {betbookRewardProgressBarChildren}
                            </BetbookRewardProgressBar>
                        )}
                        <div className="betbook-analysis-detail-title fs-18" data-atid="betbook-post-title">
                            <span className="betbook-analysis-title-specification">
                                {i18n('react.page.title.page::analysisDetail')}:{' '}
                            </span>
                            {title}
                        </div>
                        <div className="betbook-analysis-detail-text-wrapper preview" data-atid="betbook-analysis-text">
                            <NuiDate otherClass="betbook-analysis-detail-date">
                                {creationDateFormatted}
                                {modificationDate && ` • ${i18n('betbook.post.edited')}`}
                            </NuiDate>
                            {text && <Markdown forceInline>{replaceNewLines(text)}</Markdown>}
                        </div>
                        {betComponent}
                        {hash && betbookPostItemTicket}
                        {betbookDetailReactions && betbookDetailReactions}
                    </div>
                </div>
            </BetbookContextProvider>
        </>
    );
}
